import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { FicheContent } from "../components/site/FicheLieu";
import { api } from "../lib/api";
import { CONTACT } from "../data/content";

export default function LieuPage() {
  const { id } = useParams();
  const [lieu, setLieu] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => window.scrollTo(0, 0), [id]);

  useEffect(() => {
    let active = true;
    setStatus("loading");
    api
      .get(`/lieux/${id}`)
      .then(({ data }) => {
        if (active) {
          setLieu(data);
          setStatus("ok");
        }
      })
      .catch(() => active && setStatus("error"));
    return () => {
      active = false;
    };
  }, [id]);

  return (
    <div data-testid="lieu-page" className="min-h-screen bg-[#FBF7EF]" style={{ fontFamily: "Manrope, sans-serif" }}>
      <header className="max-w-[1400px] mx-auto px-5 md:px-8 pt-6 flex items-center justify-between">
        <Link to="/" data-testid="lieu-back-home">
          <img src="/logo-tpoz.png" alt="T'POZ" className="h-16 sm:h-20 w-auto" />
        </Link>
        <Link
          to="/carte"
          data-testid="lieu-back-carte"
          className="inline-flex items-center gap-2 text-sm font-semibold text-[#A66E08] hover:text-[#C6870F] transition-colors"
        >
          <ArrowLeft className="h-4 w-4" /> Tous les lieux T'POZ
        </Link>
      </header>

      <main className="mx-auto max-w-2xl px-5 py-10 md:py-14">
        {status === "loading" && (
          <div data-testid="lieu-page-loading" className="flex items-center justify-center py-24 text-pblv-inksoft">
            <Loader2 className="mr-2 h-5 w-5 animate-spin" /> Chargement de la fiche…
          </div>
        )}
        {status === "error" && (
          <div data-testid="lieu-page-error" className="rounded-3xl border border-pblv-ink/10 bg-white p-10 text-center">
            <p className="font-serif text-2xl text-pblv-ink">Fiche introuvable</p>
            <p className="mt-2 text-sm text-pblv-inksoft">
              Ce lieu n'existe pas ou n'est plus proposé dans le réseau T'POZ.
            </p>
            <Link
              to="/carte"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-pblv-mauve px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-pblv-mauvedark"
            >
              Voir la carte des lieux
            </Link>
          </div>
        )}
        {status === "ok" && lieu && (
          <div className="overflow-hidden rounded-3xl border border-pblv-ink/10 bg-pblv-bg shadow-[0_12px_40px_rgba(45,40,48,0.08)]">
            <FicheContent lieu={lieu} />
          </div>
        )}
      </main>

      <footer className="bg-[#2E2A22] text-[#FBF7EF]/60 text-center text-xs py-8">
        T'POZ — un réseau de {CONTACT.association} · {CONTACT.phone}
      </footer>
    </div>
  );
}
